module.exports = __webpack_public_path__ + "img/lens-167-minus-06.80bfd8e5.png";